import { UserRole } from './schemas';
export const UserRoleDisplay = new Map([
    [UserRole.HARDWARE_ADMIN, 'Hardware Admin'],
    [UserRole.ACTIVITY_ADMIN, 'Activity Admin'],
    [UserRole.THRESHOLD_ALERT_ADMIN, 'Threshold Alert Admin']
]);
